import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit } from "@angular/core";
import { DxSchedulerComponent } from "devextreme-angular";
import { Period } from "../../models/period.model";
import { SchedulerEvent } from "./event.model";

@Component({
  selector: "app-scheduler",
  templateUrl: "./scheduler.component.html",
  styleUrls: ["./scheduler.component.css"]
})
export class SchedulerComponent implements AfterViewInit {
  @Input() events: SchedulerEvent[] = [];
  @Input() groups = [];
  @Input() resourcesData = [];
  @Input() resources = [];
  @Input() views = ["day", "workWeek", "week", "month"];
  @Input() currentView = "workWeek";
  @Input() currentDate = new Date();
  @Input() startDayHour = 0;
  @Input() endDayHour = 24;
  @Input() cellDuration = 30;
  @Input() maxAppointmentsPerCell = "auto";
  @Input() crossScrollingEnabled = false;
  @Input() showCurrentTimeIndicator = true;
  @Input() showAllDayPanel = true;
  @Input() shadeUntilCurrentTime = false;
  @Input() groupByDate = false;
  @Input() adaptivityEnabled = false;
  @Input() height: number;
  @Input() canSchedule = true;

  @Output() datePeriodChanged = new EventEmitter<Period>();
  @Output() eventDraggedIn = new EventEmitter<any>();
  @Output() eventDraggedOut = new EventEmitter<any>();
  @Output() updateEvent = new EventEmitter<SchedulerEvent>();
  @Output() eventDraggedWithoutPermission = new EventEmitter<void>();
  @Output() requiresReload = new EventEmitter<void>();
  @Output() cellDoubleClicked = new EventEmitter<any>();

  @ViewChild(DxSchedulerComponent, { static: false }) scheduler: DxSchedulerComponent;
  datePeriod: Period;

  isPopupVisible: boolean;
  selectedEvent: SchedulerEvent;
  connectedEvents: SchedulerEvent[];
  cellClickCounter = 0;

  constructor() {
    this.onEventDraggedIn = this.onEventDraggedIn.bind(this);
    this.onEventDraggedOut = this.onEventDraggedOut.bind(this);
  }

  ngAfterViewInit() {
    this.setDatePeriod();
  }

  onOptionChanged(e: any) {
    if (e.fullName !== "currentDate" && e.fullName !== "currentView") { return; }
    // Set timeout here because values are not updated in GUI yet and will reflect the previous values if not...
    setTimeout(() => { this.notifyDatePeriodChanged(); }, 0);
  }

  private notifyDatePeriodChanged() {
    this.setDatePeriod();
    this.datePeriodChanged.emit(this.datePeriod);
  }

  private setDatePeriod() {
    this.datePeriod = { fromDate: this.scheduler.instance.getStartViewDate(), toDate: this.scheduler.instance.getEndViewDate(), name: "" };
  }

  onEventDraggedIn(e: any) {
    if (!this.canSchedule) { this.notifyPermissionDenied(); return; }
    this.eventDraggedIn.emit(e.itemData);
  }

  onEventDraggedOut(e: any) {
    if (!this.canSchedule) { this.notifyPermissionDenied(); return; }
    this.eventDraggedOut.emit(e.itemData);
  }

  private notifyPermissionDenied() {
    this.eventDraggedWithoutPermission.emit();
  }

  overrideDefaultPopup(event: any) {
    if (!event.appointmentData) { return; }
    event.cancel = true;
    const data = event.appointmentData;
    this.showCustomPopup(data);
  }

  private showCustomPopup(event: SchedulerEvent) {
    this.selectedEvent = event;
    this.connectedEvents = this.events.filter(e => e.data.ParentResourceId === event.data.ResourceId);
    this.isPopupVisible = true;
  }

  customPopupClosed(event: SchedulerEvent) {
    event.startDate = event.data.PlannedStart;
    event.endDate = event.data.PlannedStop;
    event.locked = event.data.Locked;
    this.isPopupVisible = false;
  }

  actionExecutedThatRequiresReload(keepPopupOpen = false) {
    this.isPopupVisible = keepPopupOpen;
    this.requiresReload.emit();
  }

  cellClicked(cell: any) {
    this.cellClickCounter++;
    setTimeout(() => {
      if (this.cellClickCounter >= 2) { this.cellDoubleClicked.emit(cell); }
      this.cellClickCounter = 0;
    }, 300);
  }
}
